var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{class:_vm.isClickable ? 'clickable' : '',attrs:{"src":require('@/assets/images/logo.png'),"max-width":"60","width":_vm.width},on:{"click":_vm.goHome}})
}
var staticRenderFns = []

export { render, staticRenderFns }